import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export const Values = (props) => {
  const valuesRef = useRef(null);

  useEffect(() => {
    const elements = valuesRef.current.querySelectorAll(".section-title, .value-desc, i");

    // GSAP animation with ScrollTrigger
    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 }, // Start position (off-screen to the bottom, hidden)
      {
        y: 0, // End position (original place)
        opacity: 1, // Fully visible
        duration: 2, // Animation duration
        ease: "power3.out", // Smooth easing function
        stagger: 1, // Stagger animation by 0.2 seconds for each element
        scrollTrigger: {
          trigger: valuesRef.current,
          start: "top 80%", // Trigger when the top of the element hits 80% of the viewport height
          toggleActions: "play none none reset", // Play on entering, reset on leaving
        },
      }
    );
  }, []);

  return (
    <div id="values" className="text-center" ref={valuesRef}>
      <div className="container">
        <div className="section-title">
          <h2>Who we are</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <i className={d.icon}></i>
                  <div className="value-desc">
                    <h3>{d.name}</h3>
                    <p dangerouslySetInnerHTML={{ __html: d.text }}></p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
